import { t } from '../i18n';

const backendMessageKeyMap = new Map([
  ['Email and password are required', 'notifications.backend.auth.emailAndPasswordRequired'],
  ['Invalid email or password', 'notifications.backend.auth.invalidEmailOrPassword'],
  ['Your account has been disabled. Please contact administrator.', 'notifications.backend.auth.accountDisabled'],
  ['Login successful', 'notifications.backend.auth.loginSuccessful'],
  ['Email already registered', 'notifications.backend.auth.emailAlreadyRegistered'],
  ['User ID already exists', 'notifications.backend.auth.userIdAlreadyExists'],
  ['User registered successfully', 'notifications.backend.auth.userRegisteredSuccessfully'],
  ['Logged out successfully', 'notifications.backend.auth.loggedOutSuccessfully'],
  ['Office created successfully, but failed to send invitation email', 'notifications.backend.auth.officeCreatedEmailFailed'],
  ['Office created successfully. Invitation email sent.', 'notifications.backend.auth.officeCreatedEmailSent'],
  ['User not found', 'notifications.backend.auth.userNotFound'],
  ['Re-invite is only available for office users', 'notifications.backend.auth.reinviteOnlyOfficeUsers'],
  [
    'Office re-invited successfully. Invitation email sent with new credentials.',
    'notifications.backend.auth.officeReinvitedEmailSent',
  ],
  [
    'Office password regenerated, but failed to send invitation email',
    'notifications.backend.auth.officePasswordRegeneratedEmailFailed',
  ],
  ['Invalid current password', 'notifications.backend.auth.invalidCurrentPassword'],
  ['Password changed successfully', 'notifications.backend.auth.passwordChangedSuccessfully'],
  ['Authentication required. Please provide a valid token.', 'notifications.backend.middleware.authenticationRequired'],
  ['Token has expired. Please login again.', 'notifications.backend.middleware.tokenExpired'],
  ['Invalid or malformed token. Please login again.', 'notifications.backend.middleware.invalidToken'],
  ['User not found. Token is invalid.', 'notifications.backend.middleware.tokenUserNotFound'],
  ['User role has changed. Please login again.', 'notifications.backend.middleware.roleChanged'],
  ['Authentication error occurred', 'notifications.backend.middleware.authenticationError'],
  [
    'Access denied. You do not have the required role to perform this action.',
    'notifications.backend.middleware.accessDeniedRole',
  ],
  ['Access denied. Admin role required for this operation.', 'notifications.backend.middleware.accessDeniedAdmin'],
  [
    'Access denied. Staff or Owner role required for this operation.',
    'notifications.backend.middleware.accessDeniedStaffOwner',
  ],
  ['Access denied. You are not associated with any office.', 'notifications.backend.middleware.accessDeniedNoOffice'],
  ['Access denied. Invalid user role.', 'notifications.backend.middleware.accessDeniedInvalidRole'],
  ['Internal server error', 'notifications.backend.middleware.internalServerError'],
  [
    'Access denied. You do not have permission to access this office.',
    'notifications.backend.middleware.accessDeniedOffice',
  ],
  [
    'Authentication required. Missing user identity. Please login again.',
    'notifications.backend.requests.authMissingIdentity',
  ],
  [
    'Your account has been suspended. Please contact administrator.',
    'notifications.backend.requests.accountSuspended',
  ],
  ['Request created successfully', 'notifications.backend.requests.requestCreated'],
  ['Warnings retrieved successfully', 'notifications.backend.requests.warningsRetrieved'],
  ['Invalid request serial number', 'notifications.backend.requests.invalidRequestSerial'],
  ['Request not found', 'notifications.backend.requests.requestNotFound'],
  ['Office is not associated with any officeOwner', 'notifications.backend.requests.officeOwnerMissing'],
  [
    'Access denied. You can update only your office requests.',
    'notifications.backend.requests.accessDeniedUpdateOfficeOnly',
  ],
  [
    'OFFICE can only change status OPEN->CANCELLED or RESPONSE->APPROVED',
    'notifications.backend.requests.officeStatusTransitionOnly',
  ],
  [
    'Cannot change status of a CANCELLED request',
    'notifications.backend.requests.cannotChangeCancelledStatus',
  ],
  ['Request status updated successfully', 'notifications.backend.requests.statusUpdated'],
  ['Approval token is required', 'notifications.backend.requests.approvalTokenRequired'],
  ['Approval token does not match request', 'notifications.backend.requests.approvalTokenMismatch'],
  ['Request already approved', 'notifications.backend.requests.requestAlreadyApproved'],
  [
    'Request cannot be approved in its current status',
    'notifications.backend.requests.requestInvalidStatusForApproval',
  ],
  ['Request approved successfully', 'notifications.backend.requests.requestApproved'],
  [
    'startDate and endDate are required and must be valid dates',
    'notifications.backend.requests.dateRangeRequired',
  ],
  ['Requests retrieved successfully', 'notifications.backend.requests.requestsRetrieved'],
  ['No files uploaded', 'notifications.backend.files.noFilesUploaded'],
  ['File storage is not configured', 'notifications.backend.files.fileStorageNotConfigured'],
  [
    'Access denied. You can upload files only for your office requests.',
    'notifications.backend.files.accessDeniedUploadOfficeOnly',
  ],
  ['Files uploaded successfully', 'notifications.backend.files.filesUploaded'],
  ['Signature uploaded successfully', 'notifications.backend.files.signatureUploaded'],
  ['Signature file is required', 'notifications.backend.files.signatureRequired'],
  ['Request created but signature upload failed', 'notifications.backend.files.signatureUploadFailedAfterCreate'],
  ['Only PDF, Word, or image files are allowed.', 'notifications.backend.validation.onlyPdfWordImage'],
  ['File not found', 'notifications.backend.files.fileNotFound'],
  [
    'Access denied. You can access files only for your office requests.',
    'notifications.backend.files.accessDeniedAccessOfficeOnly',
  ],
  ['File download URL generated', 'notifications.backend.files.fileDownloadUrlGenerated'],
  ['Request files retrieved', 'notifications.backend.files.requestFilesRetrieved'],
  ['Invalid user ID format', 'notifications.backend.users.invalidUserIdFormat'],
  ['No valid fields provided for update', 'notifications.backend.users.noValidFieldsForUpdate'],
  ['Invalid email format', 'notifications.backend.users.invalidEmailFormat'],
  ['Username must be between 3 and 100 characters', 'notifications.backend.users.usernameLength'],
  ['Mobile number must be 20 characters or less', 'notifications.backend.users.mobileMaxLength'],
  ['User updated successfully', 'notifications.backend.users.userUpdated'],
  ['Offices and staff retrieved successfully', 'notifications.backend.users.officesAndStaffRetrieved'],
  ['Only PDF, Word, or Excel files are allowed.', 'notifications.backend.validation.onlyPdfWordExcel'],
  ['Request serial number must be a positive integer', 'notifications.backend.validation.requestSerialPositive'],
  ['fileUuid must be a valid UUID', 'notifications.backend.validation.fileUuidValid'],
  ['officeUserUuid must be a valid UUID', 'notifications.backend.validation.officeUserUuidValid'],
  ['rqst_prmsn_date must be a valid ISO date', 'notifications.backend.validation.permissionDateIso'],
  ['rqst_sn must be a positive integer', 'notifications.backend.validation.requestSnPositive'],
  ['startDate must be a valid ISO date', 'notifications.backend.validation.startDateIso'],
  ['endDate must be a valid ISO date', 'notifications.backend.validation.endDateIso'],
  ['personId is required', 'notifications.backend.validation.personIdRequired'],
  ['token is required', 'notifications.backend.validation.tokenRequired'],
  ['Username must be between 3 and 50 characters', 'notifications.backend.validation.usernameLengthShort'],
  [
    'Username can only contain Hebrew letters, English letters, numbers and spaces',
    'notifications.backend.validation.usernameAllowed',
  ],
  ['User ID must be between 1 and 20 characters', 'notifications.backend.validation.userIdLengthShort'],
  ['User ID can only contain numbers', 'notifications.backend.validation.userIdNumbersOnly'],
  ['Please provide a valid email address', 'notifications.backend.validation.validEmailAddress'],
  ['Email must be between 5 and 255 characters', 'notifications.backend.validation.emailLength'],
  ['Mobile number contains invalid characters', 'notifications.backend.validation.mobileInvalidChars'],
  ['Office owner must be 50 characters or less', 'notifications.backend.validation.officeOwnerMax'],
  [
    'Office owner can only contain Hebrew, Arabic, English letters, numbers and spaces',
    'notifications.backend.validation.officeOwnerAllowed',
  ],
  ['Username is required', 'notifications.backend.validation.usernameRequired'],
  ['Username must be between 3 and 100 characters', 'notifications.backend.validation.usernameLengthLong'],
  [
    'Username can only contain letters, numbers, and underscores',
    'notifications.backend.validation.usernameLettersNumbersUnderscore',
  ],
  ['Password is required', 'notifications.backend.validation.passwordRequired'],
  ['Password cannot be empty', 'notifications.backend.validation.passwordNotEmpty'],
  ['Password must be at least 8 characters long', 'notifications.backend.validation.passwordMinLength'],
  [
    'Password must contain at least one uppercase letter, one lowercase letter, and one number',
    'notifications.backend.validation.passwordUpperLowerNumber',
  ],
  [
    'Password must contain at least one special character',
    'notifications.backend.validation.passwordSpecialChar',
  ],
  ['User ID must be between 1 and 100 characters', 'notifications.backend.validation.userIdLengthLong'],
  [
    'User ID can only contain letters, numbers, underscores, and hyphens',
    'notifications.backend.validation.userIdAllowed',
  ],
  ['Role must be one of: STAFF, OWNER, ADMIN, OFFICE', 'notifications.backend.validation.roleMustBeOneOf'],
  ['Login URL must be a valid URL', 'notifications.backend.validation.loginUrlValid'],
  ['User ID is required', 'notifications.backend.validation.userIdRequired'],
  ['Current password is required', 'notifications.backend.validation.currentPasswordRequired'],
  ['New password must be at least 8 characters long', 'notifications.backend.validation.newPasswordMinLength'],
  [
    'New password must contain at least one uppercase letter, one lowercase letter, and one number',
    'notifications.backend.validation.newPasswordUpperLowerNumber',
  ],
  [
    'New password must contain at least one special character',
    'notifications.backend.validation.newPasswordSpecialChar',
  ],
  ['Validation failed', 'notifications.backend.validation.validationFailed'],
]);

const translateBackendMessage = (message) => {
  if (!message || typeof message !== 'string') {
    return message;
  }

  const trimmed = message.trim();
  const key = backendMessageKeyMap.get(trimmed);
  if (key) {
    return t(key);
  }

  const alreadyExistsMatch = trimmed.match(/^(.+)\s+already exists$/);
  if (alreadyExistsMatch) {
    return t('notifications.backend.users.fieldAlreadyExists', {
      field: alreadyExistsMatch[1],
    });
  }

  const duplicateMatch = trimmed.match(
    /^A request for this person ID was already created in the last (\d+) days \(request #(.+)\)$/
  );
  if (duplicateMatch) {
    return t('requests.duplicateBlocked', { days: duplicateMatch[1], rqstId: duplicateMatch[2] });
  }

  const statusListMatch = trimmed.match(/^status must be one of:\s*(.+)$/i);
  if (statusListMatch) {
    return t('notifications.backend.validation.statusMustBeOneOf', {
      statuses: statusListMatch[1],
    });
  }

  const statusAllowedMatch = trimmed.match(/^Status must be one of:\s*(.+)$/);
  if (statusAllowedMatch) {
    return t('notifications.backend.validation.statusAllowed', {
      statuses: statusAllowedMatch[1],
    });
  }

  const roleAllowedMatch = trimmed.match(/^Role must be one of:\s*(.+)$/);
  if (roleAllowedMatch) {
    return t('notifications.backend.validation.roleAllowed', {
      roles: roleAllowedMatch[1],
    });
  }

  const fileTooLargeMatch = trimmed.match(/^File exceeds the (\d+)MB limit$/);
  if (fileTooLargeMatch) {
    return t('notifications.backend.files.fileTooLarge', {
      size: fileTooLargeMatch[1],
    });
  }

  return message;
};

export { translateBackendMessage };
